module.exports = __webpack_public_path__ + "img/TwentythreeLogo.5db0fdb0.svg";